export default function CTA() {
  return (
    <section className="py-32 bg-gradient-to-br from-teal-600 via-teal-500 to-emerald-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight">
          READY TO START SWAPPING?
        </h2>
        <p className="text-xl text-white/90 mb-4">
          Join thousands making a difference
        </p>
        <p className="text-xl text-white/90 mb-12">
          One swap at a time
        </p>

        <button className="inline-flex items-center gap-4 bg-gray-900 text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-gray-800 transition-all shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap">
          <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
            <i className="ri-shopping-bag-3-line text-white text-xl"></i>
          </div>
          CREATE ACCOUNT
          <i className="ri-arrow-right-line text-xl"></i>
        </button>
      </div>
    </section>
  );
}
